import axios from "axios";
import { Formik, useFormik } from "formik";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import * as Yub from "yup";
import BaseURL from '../Utilities/BaseUrl.js'
import validate from "../Utilities/Passwordvalidation.js";
import notify from "../Utilities/Notify.js";
import { Helmet } from "react-helmet";
export default function Register() {
 
  const [loading, setloading] = useState(true);
  const [disab, setdisab] = useState(true);
 let navigate= useNavigate();
  
  function tranferPass() {
    
    let ey1=document.querySelector('.eye1');
    let inp1=document.querySelector('#password');
    ey1.innerHTML=`<i class="fa-solid fa-eye eyeicon fa-xl cursor-pointer"></i>`
    inp1.setAttribute('type',Text);
  }
  function tranferRepass() {
    
    let ey1=document.querySelector('.eye2');
    let inp1=document.querySelector('#rePassword');
    ey1.innerHTML=`<i class="fa-solid fa-eye eyeicon fa-xl cursor-pointer"></i>`
    inp1.setAttribute('type',Text);
  }
  
  let Formik = useFormik({
    initialValues: {
      name: "",
      email: "",
      password: "",
      rePassword: "",
      phone: "",
    },

    validate: validate,

    onSubmit: (values) => {
      setloading(false);
      setdisab(false);
      axios.post(`${BaseURL}auth/signup`, values)
        .then((data) => {
          if(data.status==201)
        
       notify('success',data.data.message);
        
            navigate('/login');

        }
         

      
        ).catch((error) => {
          if (error.response.status == 409)
            
        notify('error',error.response.data.message);
         
          setloading(true);
          setdisab(true)
        });
    },
  });

  return (
    <>
   <Helmet>
        <title>Register</title>
        
    </Helmet>
      <div className="container pt-5 pb-5">
        <div className="row">
          <div className="col-12">
           


            <div className="registerForm">
              <h2 className="mb-5">Register Now .....</h2>

              <form onSubmit={Formik.handleSubmit}>
                <label htmlFor="name">Name :</label>
                <input
                  onChange={Formik.handleChange}
                  onBlur={Formik.handleBlur}
                  type="text"
                  name="name"
                  id="name"
                  placeholder="Enter Your Name"
                  className="form-control mt-2 w-75 mb-4 shadow-none"
                  value={Formik.values.name}
                />
                {Formik.errors.name && Formik.touched.name ? (
                  <div className="alert alert-danger w-75">
                    {Formik.errors.name}
                  </div>
                ) : (
                  ""
                )}

                <label htmlFor="email">Email :</label>
                <input
                  onChange={Formik.handleChange}
                  onBlur={Formik.handleBlur}
                  type="email"
                  name="email"
                  id="email"
                  placeholder="Enter Your Email"
                  className="form-control mt-2 w-75 mb-4 shadow-none"
                  value={Formik.values.email}
                />
                {Formik.errors.email && Formik.touched.email ? (
                  <div className="alert alert-danger w-75">
                    {Formik.errors.email}
                  </div>
                ) : (
                  ""
                )}
                <label htmlFor="password">Password :</label>
                <div className="passwordField">
                
                <input
                  onChange={Formik.handleChange}
                  onBlur={Formik.handleBlur}
                  type="password"
                  name="password"
                  id="password"
                  placeholder="Enter Your password"
                  className="form-control mt-2 w-75 mb-4 shadow-none"
                  value={Formik.values.password}
                /> <span className="eye1"><i className="fa-solid fa-eye-slash eyeicon fa-xl cursor-pointer" onClick={tranferPass}></i></span></div>
                {Formik.errors.password && Formik.touched.password ? (
                  <div className="alert alert-danger w-75">
                    {Formik.errors.password}
                  </div>
                ) : (
                  ""
                )}
                <label htmlFor="rePassword">rePassword :</label>
                <div className="passwordField">
                <input
                  onChange={Formik.handleChange}
                  onBlur={Formik.handleBlur}
                  type="password"
                  name="rePassword"
                  id="rePassword"
                  placeholder="Confirm Your Password"
                  className="form-control mt-2 w-75 mb-4 shadow-none"
                  value={Formik.values.rePassword}
                /> <span className="eye2"><i className="fa-solid fa-eye-slash eyeicon fa-xl cursor-pointer" onClick={tranferRepass} ></i></span> </div>
                {Formik.errors.rePassword && Formik.touched.rePassword ? (
                  <div className="alert alert-danger w-75">
                    {Formik.errors.rePassword}
                  </div>
                ) : (
                  ""
                )}

                <label htmlFor="Phone">Phone :</label>
                <input
                  onChange={Formik.handleChange}
                  onBlur={Formik.handleBlur}
                  type="text"
                  name="phone"
                  id="phone"
                  placeholder="Enter Your phone"
                  className="form-control mt-2 w-75 shadow-none"
                  value={Formik.values.phone}
                />
                {Formik.errors.phone && Formik.touched.phone ? (
                  <div className="alert alert-danger w-75">
                    {Formik.errors.phone}
                  </div>
                ) : (
                  ""
                )}

                <button
                  type="submit"
                  className="btn bg-main px-5 py-2 mt-5 text-white" disabled={!(Formik.isValid&&Formik.dirty&&disab)}
                >
                  {loading?<span>sign Up</span> : <span className="spinner-grow text-white  fs-5" role="status" width={10}>
</span>}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
